import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, isLoading, isAuthenticated } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8F7FC]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#5A67D8]"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    // Redirect to the user's natural home based on role.
    const dashboardPaths = {
      super_admin: '/superadmin/dashboard',
      doctor: '/doctor/dashboard',
      clinic_admin: '/clinic/dashboard',
      employee: '/employee/dashboard',
      credit_admin: '/credit-admin/credits',
      mother: '/mom/dashboard',
    };
    // Defensive: if the role isn't in the map (unknown role) fall back to /login
    return <Navigate to={dashboardPaths[user.role] || '/login'} replace />;
  }

  return <>{children}</>;
};
